/// <reference path="../wpt.ts" />
/*
    Allows us to go into a detail type view directly, which may be useful to certain solutions e.g. Policies and Procedures
*/
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.Navigator";
        class NavigatorWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("NavigatorWidgetTypeClass.createInstance()");
                    return new NavigatorWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("NavigatorWidgetTypeClass._storeHtml()");
                    NavigatorWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("NavigatorWidgetTypeClass::constructor");
                this._allowedOnLogon = true;
                if (NavigatorWidgetInstanceClass.HtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/Navigator/navigator.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.NavigatorWidgetTypeClass = NavigatorWidgetTypeClass;
        class NavigatorWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._autoLaunchRecord = null;
                this._typedConfig = null;
                this._noRecords = null;
                this._navigatorHolder = null;
                this._launchTriggers = null;
                this._triggeringContext = null;
                this._buttonPalette = null;
                this.presentInstance = () => {
                    this._log.info("NavigatorWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = NavigatorWidgetInstanceClass.HtmlData;
                    this._noRecords = this._container.querySelector('#navigatorNoRecords');
                    this._navigatorHolder = this._container.querySelector('#navigatorHolder');
                    this._prepareErrorBanner();
                    this._widgets.setTitle(this._config, this._container.querySelector('#navigatorWidgetTitle'), 'STR_WPT_NAVIGATOR_TITLE');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    // Set up configuration
                    let type = "Buttons";
                    if (this._typedConfig.hasOwnProperty('Type') && this._typedConfig.Type)
                        type = this._typedConfig.Type;
                    let orientation = "Horizontal";
                    if (type != "Tiles" && this._typedConfig.hasOwnProperty('Orientation') && this._typedConfig.Orientation)
                        orientation = this._typedConfig.Orientation;
                    if (this._typedConfig.hasOwnProperty('LaunchTriggers') && this._typedConfig.LaunchTriggers && (this._typedConfig.LaunchTriggers.length > 0))
                        this._launchTriggers = this._typedConfig.LaunchTriggers;
                    else
                        this._launchTriggers = [];
                    this._core.Functions.addDefaultsToTriggerEvents(this._launchTriggers);
                    // Immediate UI effects
                    this._core.Helper.setElementTranslation(this._container.querySelector('#navigatorNoRecordsMessage'), 'STR_WPT_NO_VIEWS_CONFIGURED');
                    if (orientation == "Horizontal" || this._typedConfig.SuppressBorder) {
                        this._navigatorHolder.classList.add('widget__body-item--no-padding');
                    }
                    let usePrimary = false;
                    if (this._config.hasOwnProperty('SuppressHeading') && this._config.SuppressHeading === true) {
                        usePrimary = true;
                    }
                    let buttonConfig = {
                        Type: type,
                        Orientation: orientation,
                        SuppressNoItemsBanner: true,
                        UsePrimaryColour: usePrimary
                    };
                    if (this._typedConfig.hasOwnProperty('TileSettings') && this._typedConfig.TileSettings) {
                        buttonConfig.TileSettings = this._typedConfig.TileSettings;
                    }
                    this._buttonPalette = new Widgets.ComponentButtonPalette(this._core, this._navigatorHolder, this, buttonConfig, this._layoutClicked);
                    this._buttonPalette.present();
                    this._displayLayoutLinks();
                    this._type.instanceReady(this.Handle);
                    if (this._autoLaunchRecord != null) {
                        switch (this._autoLaunchRecord.Type) {
                            case 'Application':
                                this._launchApplication(this._autoLaunchRecord);
                                break;
                            case 'DetailView':
                                this._launchLayout(this._autoLaunchRecord);
                                break;
                            case 'URL':
                                this._launchURL(this._autoLaunchRecord);
                                break;
                            default:
                                this.addError("Auto-launch record has an unknown type.");
                                break;
                        }
                    }
                };
                this._displayLayoutLinks = () => {
                    this._log.info("NavigatorWidgetInstanceClass._displayLayoutLinks()");
                    // Jump out if we've got no records
                    if (!this._typedConfig.hasOwnProperty("LayoutRecords") || (this._typedConfig.LayoutRecords.length == 0)) {
                        this._core.Functions.showElement(this._noRecords);
                        return;
                    }
                    // Need to do some application filtering
                    let visibleApplications = this._core.Config.getVisibleApplications();
                    let selectedApplication = this._core.Config.getSelectedApplication();
                    let options = [];
                    this._typedConfig.LayoutRecords.forEach(target => {
                        // Filter out applications before display, we won't be showing/hiding them dynamically
                        if (target.Type == 'Application') {
                            if (selectedApplication.Name == target.ApplicationName)
                                return;
                            let visibleTarget = visibleApplications.find(app => app.Name == target.ApplicationName);
                            if (!visibleTarget)
                                return;
                        }
                        if (target.Type == 'DetailView') {
                            if (!this._core.isUserLoggedIn())
                                return;
                        }
                        // Now get about building the display
                        if (!target.hasOwnProperty('AutoLaunch') || !target.AutoLaunch) {
                            let option = {
                                Identifier: target.Identifier,
                                Group: target.Type
                            };
                            if (target.hasOwnProperty('Label') && target.Label) {
                                option.Label = target.Label;
                            }
                            if (target.hasOwnProperty('Icon') && target.Icon) {
                                option.Icon = target.Icon;
                            }
                            else {
                                let idName = null;
                                switch (target.Type) {
                                    case "Application":
                                        idName = target.ApplicationName;
                                        break;
                                    case "DetailView":
                                        idName = target.DetailViewName;
                                        break;
                                    case "URL":
                                        idName = target.URL;
                                        break;
                                    default:
                                        break;
                                }
                                let iconId = {
                                    Type: target.Type,
                                    Name: idName
                                };
                                option.Icon = this._core.Helper.getButtonIcon(iconId);
                            }
                            if (target.hasOwnProperty('TileSettings') && target.TileSettings) {
                                option.TileSettings = target.TileSettings;
                            }
                            if (target.Type == 'DetailView' && this._currentLayout == target.DetailViewName) {
                                option.Hidden = true;
                            }
                            options.push(option);
                        }
                        else
                            this._autoLaunchRecord = target;
                    });
                    this._buttonPalette.displayOptions(options);
                };
                this._layoutClicked = (identifier) => {
                    this._log.info("NavigatorWidgetInstanceClass._layoutClicked()");
                    this._triggeringContext = null;
                    this._tryLaunch(identifier);
                };
                this._tryLaunch = (identifier) => {
                    this._log.info("NavigatorWidgetInstanceClass._tryLaunch()");
                    let launchRecord = this._typedConfig.LayoutRecords.find(record => record.Identifier == identifier);
                    if (launchRecord && launchRecord.hasOwnProperty('Popup') && (launchRecord.Popup != null)) {
                        if (launchRecord.Popup.hasOwnProperty('CanCancel') && launchRecord.Popup.CanCancel) {
                            this._core.Helper.presentWarningContinueModal(launchRecord.Popup.Text, this._launch.bind(this, identifier), 'STR_WPT_CONTINUE_HEADING');
                        }
                        else {
                            let modalConfig = new WPTNamespace.ModalShowConfig();
                            modalConfig.AdditionalHiddenCallback = this._launch.bind(this, identifier);
                            this._core.Helper.presentMessageModal(WPTNamespace.ModalType.FIRST, launchRecord.Popup.Text, 'STR_WPT_MESSAGE', modalConfig);
                        }
                    }
                    else
                        this._launch(identifier);
                };
                this._launch = (identifier) => {
                    this._log.info("NavigatorWidgetInstanceClass._launch()");
                    let launchRecord = this._typedConfig.LayoutRecords.find(record => record.Identifier == identifier);
                    if (launchRecord) {
                        switch (launchRecord.Type) {
                            case 'Application':
                                this._applyKeywordFilters(launchRecord);
                                this._launchApplication(launchRecord);
                                break;
                            case 'DetailView':
                                this._applyKeywordFilters(launchRecord);
                                this._launchLayout(launchRecord);
                                break;
                            case 'URL':
                                this._launchURL(launchRecord);
                                break;
                        }
                    }
                    else
                        this.addError(`Attempt to find launch record with unrecognised identifier '${identifier}'`);
                };
                this._applyKeywordFilters = (launchRecord) => {
                    this._log.info("NavigatorWidgetInstanceClass._applyKeywordFilters()");
                    if (!launchRecord.hasOwnProperty('KeywordFilters') || !launchRecord.KeywordFilters || (launchRecord.KeywordFilters.length == 0))
                        return;
                    launchRecord.KeywordFilters.forEach(filter => {
                        // Preservation setting
                        let preserve = false;
                        if (filter.hasOwnProperty('PreserveExisting') && filter.PreserveExisting)
                            preserve = true;
                        // Grab value for processing
                        let value = "";
                        if (filter.hasOwnProperty('Value') && filter.Value)
                            value = filter.Value;
                        // Check for value inheritance
                        let expansion = this._core.Context.expandMacro(value);
                        if (expansion.length > 0)
                            value = expansion[0];
                        // Actually set the setting
                        this._core.Context.setSessionVariable(filter.Id, value, false, !preserve);
                    });
                };
                this._launchLayout = (launchRecord) => {
                    this._log.info("NavigatorWidgetInstanceClass._launchLayout()");
                    // Sanity check
                    if (!launchRecord.hasOwnProperty('DetailViewName') || !launchRecord.DetailViewName) {
                        this.addError("Attempt to launch detail view with no DetailViewName configured");
                        console.warn("NavigatorWidgetInstanceClass: Attempt to launch detail view with no DetailViewName configured");
                        return;
                    }
                    // Don't do anything if we are already here
                    if (launchRecord.DetailViewName == this._core.Navigation.Details.getActiveLayoutName())
                        return;
                    // Updated behaviour - we now retain the home button by default as autolaunch may not be our modus operandi
                    if (launchRecord.hasOwnProperty("RetainHomeButton") && (launchRecord.RetainHomeButton == false)) {
                        // TODO: maybe make this selector more specific in case there are other homeButton elements in custom code
                        this._core.Functions.hideElement(this._core.Navigation.Menu.HomeButton);
                    }
                    if (launchRecord.hasOwnProperty("OverrideHomeTarget") && (launchRecord.OverrideHomeTarget)) {
                        // Update home target so we can treat a detail view as the home page
                        this._core.Config.getApplicationConfig().HomeButtonTargetLayout = launchRecord.OverrideHomeTarget;
                    }
                    let usingOriginatingContext = false;
                    if ((this._currentLayout != WPTNamespace.Navigation.HOME_VIEW_NAME) && launchRecord.hasOwnProperty("UseOriginatingContext") && launchRecord.UseOriginatingContext) {
                        usingOriginatingContext = true;
                    }
                    let usingTriggeringContext = false;
                    if (launchRecord.hasOwnProperty("ForwardTriggeringContext") && launchRecord.ForwardTriggeringContext && this._triggeringContext) {
                        usingTriggeringContext = true;
                        // Trigger takes precedence
                        usingOriginatingContext = false;
                    }
                    // Sort out nav event activator
                    let activator = null;
                    if (!launchRecord.hasOwnProperty("SuppressActivator") || (launchRecord.SuppressActivator == false)) {
                        if (launchRecord.hasOwnProperty("ProxyActivator")) {
                            activator = this._core.Widgets.getInstanceById(launchRecord.ProxyActivator);
                            if (!activator) {
                                if (this._core.Navigation.Details.getActiveLayout()) {
                                    activator = this._core.Navigation.Details.getActiveLayout().getWidgetInstanceByPlaceholder(launchRecord.ProxyActivator);
                                }
                                else
                                    activator = this;
                            }
                        }
                        else
                            activator = this;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`setting activator to ${activator.Id}`);
                        }
                    }
                    // Work with original launch context if necessary
                    let navEvent = null;
                    if (usingOriginatingContext) {
                        navEvent = this._core.Navigation.Details.getActiveLayout().OriginalLaunchContext;
                        navEvent.ActivatingWidget = activator;
                    }
                    else if (usingTriggeringContext) {
                        navEvent = this._triggeringContext;
                    }
                    else {
                        // Specify an activation type
                        let activationEnum = WPTNamespace.Navigation.LayoutActivationType.NONE;
                        if (launchRecord.hasOwnProperty("LaunchType"))
                            activationEnum = WPTNamespace.Navigation.LayoutActivationType[launchRecord.LaunchType];
                        navEvent = new WPTNamespace.Navigation.ActivationContext(activator, activationEnum);
                        // Grab launch context - could be anything in here
                        if (launchRecord.hasOwnProperty("LaunchContext"))
                            navEvent.PrimaryContext = launchRecord.LaunchContext;
                        if (launchRecord.hasOwnProperty("LaunchActivationID"))
                            navEvent.ActivationID = launchRecord.LaunchActivationID;
                    }
                    // Execute
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`launching layout ${launchRecord.DetailViewName} with ID ${navEvent.ActivationID}`);
                    }
                    let dvName = (launchRecord.DetailViewName == '[[CURRENT]]') ? this._currentLayout : launchRecord.DetailViewName;
                    navEvent.Layout = dvName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._launchApplication = (launchRecord) => {
                    this._log.info("NavigatorWidgetInstanceClass._launchApplication()");
                    // Sanity check
                    if (!launchRecord.hasOwnProperty('ApplicationName') || !launchRecord.ApplicationName) {
                        this.addError(`Attempt to launch application with no ApplicationName configured`);
                        console.warn(`Attempt to launch application with no ApplicationName configured`);
                        return;
                    }
                    this._core.Config.changeApplication(launchRecord.ApplicationName);
                };
                this._launchURL = (launchRecord) => {
                    this._log.info("NavigatorWidgetInstanceClass._launchURL()");
                    // Sanity check
                    if (!launchRecord.hasOwnProperty('URL') || !launchRecord.URL) {
                        this.addError(`Attempt to launch URL with no URL configured`);
                        console.warn(`Attempt to launch URL with no URL configured`);
                        return;
                    }
                    // Launch in this window (probably only for very limited applications) or new tab
                    if (launchRecord.hasOwnProperty('UseSameWindow') && launchRecord.UseSameWindow)
                        window.location.assign(this._core.Context.applyAllMacros(launchRecord.URL));
                    else
                        window.open(this._core.Context.applyAllMacros(launchRecord.URL), '_blank', 'noopener,noreferrer');
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("NavigatorWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._typedConfig = this._config;
            }
            setCurrentLayout(layout) {
                this._log.info("NavigatorWidgetInstanceClass.setCurrentLayout()");
                super.setCurrentLayout(layout);
                if (layout == "[[-CACHE-]]")
                    return;
                // We need to update the UI based on where we are
                let dvRecords = this._typedConfig.LayoutRecords.filter(r => r.Type == 'DetailView');
                let navigator = this;
                dvRecords.forEach(record => {
                    if (record.DetailViewName == navigator._currentLayout) {
                        navigator._buttonPalette.hideOption(record.Identifier);
                    }
                    else {
                        navigator._buttonPalette.showOption(record.Identifier);
                    }
                });
            }
            activate(context) {
                this._log.info("NavigatorWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                if (this._launchTriggers.length > 0) {
                    // Loop with iterator so we can escape when necessary
                    for (let i = 0; i < this._launchTriggers.length; i++) {
                        let trigger = this._launchTriggers[i];
                        if (this._core.Functions.triggerEventMatches(trigger, context)) {
                            if (trigger.Context) {
                                this._triggeringContext = context;
                                this._tryLaunch(this._core.Context.applyAllMacros(trigger.Context));
                            }
                            // Only trigger once
                            return;
                        }
                        else {
                            continue;
                        }
                    }
                }
            }
        }
        NavigatorWidgetInstanceClass.HtmlData = null;
        Widgets.NavigatorWidgetInstanceClass = NavigatorWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
